import * as builtin from "./builtin.js";
/**
 * @public
 */
export var JSON;
(function (JSON) {
    function parse(value) {
        return builtin.JSON.parse(value);
    }
    JSON.parse = parse;
    function stringify(value) {
        return builtin.JSON.stringify(value);
    }
    JSON.stringify = stringify;
})(JSON || (JSON = {}));
//# sourceMappingURL=json.js.map